import React from "react";
import History from "./history";

function capitalizeString(str) {
    // Split the string into an array of words
    let words = str?.split(' ');

    // Capitalize the first letter of each word
    for (let i = 0; i < words?.length; i++) {
        words[i] = words?.[i]?.charAt(0).toUpperCase() + words?.[i]?.slice(1)?.toLowerCase();
    }

    // Join the words back into a single string
    return words?.join(' ');
}

export const ErrorMessageFunction = ({ basicPath, name, customMessage, customHandler, externalURL }: { basicPath?: string, name?: string, customMessage?: string, customHandler?: string, externalURL?: string }) => {
    const handleClick = () => {
        if (!!externalURL) {
            return window.open(externalURL, '_blank')
        }
        return History.navigate(customHandler);
    }
    const message = customMessage
        ? customMessage
        : `${capitalizeString(name || basicPath)} Not Found!`;
    const spanElement = React.createElement(
        'span',
        {
            onClick: handleClick,
            className: 'cursor-pointer font-semibold underline-offset-2',
        },
        `Click here to create ${(name || basicPath)?.toLowerCase()}.`
    );

    return React.createElement('p', null, `${message} `, spanElement);
};